
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as health9REJnQbQMP3xHfZqdCcRKxwWCzbvXD7Zxsfc4ygE7T0Meta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_93u4KFWlsXXnWOKGI99kPzJ_45WshRq8Oprr5K5FK2bUgNEMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[...slug].vue?macro=true";
import { default as guidesy4uy5QQiOnLrX_45w_45UDJcZ78YsyknFEi2e5q3acvuhJ8Meta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue?macro=true";
import { default as port_45parkingvTmJnPjKQbGUgXI4fzpvZ_45luvj3SpGgb9IQG7DEMchkMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45parkingtD73jTbmUReBF_45NH1Gh3vtwiH_45OIP5F3gtWjJFwKA7UMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-parking.vue?macro=true";
import { default as parking_45couponsA3blWYlblQf5m37JYIowlOFprrG_45XPP30pbVjvHIj7cMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/parking-coupons.vue?macro=true";
import { default as _91result_93KECYXJnParsjB0WOr_p_Zh5AfwIAyZ3k0rzfi1Xk09wMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/flight-status/[result].vue?macro=true";
import { default as airport_45shuttlesymsusabMlYzuaBJAU_45UFRxn7hvQYVlrG5wcOjVyn5_0Meta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-shuttles.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93gGy7cwuFdBHlbt0H4ij9CnCMOeFuQGuBRcvRigk0gDcMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as off_45airport_45parkingb8algZ0_45kUYfMSVx_IWOLsVnloMSVzWNEiGnEBc4WN8Meta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/off-airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_932lZKo72iEHgSi9IgFt6XgmHxgoxMFHri64UkhCs7BJ0Meta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as port_45hotels_45with_45parkinghjoakBAooAFrSluMaLlVR2SrvV0vHTxYGtpMhR8lWzAMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingGQX6VmpPYfLMrkMEdwJeo6TluIDiulA491zwBxDzzQcMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93W8Mh7xBA7jTE8PKPxnHemgYZ2Mq9AqwD_cY82oS_JDcMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stubcQ292Mc6d4zlEBFVfiYETpOo7stHheLXSWK1ODWEBtUMeta } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.12_db0@0.3.2_eslint@8.57.1_ioredis@_e5dba485d92a137be6e9c9e4a088250a/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubcQ292Mc6d4zlEBFVfiYETpOo7stHheLXSWK1ODWEBtU } from "/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.15.12_db0@0.3.2_eslint@8.57.1_ioredis@_e5dba485d92a137be6e9c9e4a088250a/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[...slug].vue")
  },
  {
    name: "IATA-guides___en",
    path: "/:IATA()/guides",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "IATA-parking-coupons___en",
    path: "/:IATA()/parking-coupons",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/parking-coupons.vue")
  },
  {
    name: "flight-status-result___en",
    path: "/flight-status/:result()",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/flight-status/[result].vue")
  },
  {
    name: "IATA-airport-shuttles___en",
    path: "/:IATA()/airport-shuttles",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-shuttles.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "IATA-off-airport-parking___en",
    path: "/:IATA()/off-airport-parking",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/off-airport-parking.vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: "Guides___en",
    path: "/:IATA([a-z]{3})",
    component: () => import("/codebuild/output/src1247610591/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue")
  },
  {
    name: component_45stubcQ292Mc6d4zlEBFVfiYETpOo7stHheLXSWK1ODWEBtUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubcQ292Mc6d4zlEBFVfiYETpOo7stHheLXSWK1ODWEBtU
  }
]